<script setup>
import { computed } from "vue";
import { useTheme } from "vuetify";
import { useRouter, useRoute } from "vue-router";
import { userStore } from "@/store/UserStore";
import { useI18n } from "vue-i18n";

console.log("==========> start  <==============");
//firebase 분석 호출
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
const firebaseConfig = {
  apiKey: "AIzaSyA8WV3Nn-Zzrnjo-ipohQTN6z1uyi9KbGM",
  authDomain: "miri-serivce.firebaseapp.com",
  projectId: "miri-serivce",
  storageBucket: "miri-serivce.appspot.com",
  messagingSenderId: "17929557552",
  appId: "1:17929557552:web:03fb6948f74bbda51abff5",
  measurementId: "G-F41GJWRYV9"
};
// // Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
console.log("==========> end  <==============");

const theme = useTheme();
const router = useRouter();
const route = useRoute();

const useUserStore = userStore();

const { t } = useI18n();

// const toggleLocale = ref("ko");
const chagneTheme = () => {
  theme.global.name.value == "light"
    ? (theme.global.name.value = "dark")
    : (theme.global.name.value = "light");
};
const localeChange = () => {
  useUserStore.userInfo.locale == "ko_kr" ||
  !!useUserStore.userInfo.locale == false
    ? useUserStore.changeLocale("en_gn")
    : useUserStore.changeLocale("ko_kr");
};
const computedColor = computed(() => {
  return theme.global.name.value == "light" ? "black" : "white";
});
const linkToMenual = async () => {
  logEvent(analytics, 'PC_매뉴얼', {
    content_type: 'image',
    content_id: 'P12379'
  });
  await useUserStore.setUseLog("MENUAL");
  let menualUrl;
  if(useUserStore.userInfo.nation == "KOR") {
    menualUrl = "https://www.hyundaielevator.com/upload/miri/MIRI_PC.pdf";
  }
  else {
    menualUrl = "https://www.hyundaielevator.co.kr/upload/notice/MIRI%20Customer%20Portal(Overseas)_PC%20Web_User%20Guide_v0_251029.pdf";
  }
  window.open(menualUrl, "_blank");
};

const refresh = async () => {
  if (route.path == "/dashboard") {
    await router.push("/refresh");
    await router.push("/dashboard");
  } else {
    await router.push("/refresh");

    await router.push("/map_page");
  }
};
// watch(i18n.locale, (newVal, oldVal) => {
//   if (i18n.locale.value == "en") {
//     getLocale("en_gn");
//     getStatus("en_gn");
//   } else {
//     getLocale("ko_kr");
//     getStatus("ko_kr");
//   }
// });
</script>

<template>
  <v-btn
    v-if="route.path == '/dashboard' || route.path == '/map_page'"
    icon="mdi-refresh"
    variant="plain"
    @click="[refresh()]"
  ></v-btn>
  <v-btn-toggle color="primary">
    <!-- <v-btn variant="plain" icon @click="localeChange">
      {{
        useUserStore.userInfo?.locale == "ko_kr" ||
        !!useUserStore.userInfo?.locale == false
          ? "KO"
          : "EN"
      }}
    </v-btn> -->

    <v-btn
      rounded="xl"
      @click="chagneTheme"
      variant="plain"
      :icon="
        theme.global.name.value == 'light'
          ? 'mdi-weather-sunny'
          : 'mdi-weather-night'
      "
    >
    </v-btn>

  </v-btn-toggle>
  <v-btn-toggle>
  <v-btn
    icon="mdi-book"
    variant="plain"
    style="width:100%;"
    @click="linkToMenual"
  >{{ t("MANUAL") }}
  </v-btn>
   </v-btn-toggle>
</template>

<style lang="scss">


.g2-html-annotation {
  color: v-bind(computedColor) !important;
}
.g2-tooltip {
  background: rgb(84, 82, 82) !important;
  * {
    color: white !important;
  }
  width: 100% !important;
}
</style>
